import React, {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchInvestisseurs } from "../../../../../redux/investisseurs/investisseurAction";


function InvestisseurDetails({ invest }) {
  const dispatch = useDispatch();
  const investisseurDetails = useSelector((state) => state.investisseurs);
console.log("investisseurDetails", investisseurDetails);
  useEffect(() => {
    dispatch(fetchInvestisseurs(invest.id));
  }, [dispatch, invest.id]);

  return (
    <div className="modal-dialog modal-dialog-centered  easypm-modal-dialog modal-lg">
      <div className="modal-content easypm-modal-content">
        <div className="modal-header easypm-modal-header">
          <h5 className="modal-title easypm-modal-title">
            Détails de l'investisseur
          </h5>
          <button
            type="button"
            className="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body easypm-modal-body">
          <div className="add-family-form-container">
            <form className="crud-form">
              <div className="row position-relative">
                <div className="col-md-12 crud-col-item d-flex justify-content-center">
                  <div className="form-group align-items-center bloc-prestataire-profil position-relative text-center">
                    {/* <img
                      src={
                        user?.avatar && !user?.avatar?.includes("default.png")
                          ? baseUrl + user?.avatar
                          : avatar
                      }
                      className="img-utilisateur"
                      alt="user-avatar"
                      height="50"
                      width="50"
                    /> */}
                    {/* <h3 className="profil-nom text-wrap">
                      {invest?.investisseur.prenom + " " + invest?.investisseur.nom}
                    </h3>
                    <h6 className="profil-nom text-wrap">
                      {invest?.investisseur.email}
                    </h6> */}
                  </div>
                </div>
              </div>
              <div className="row position-relative p-3 mb-5">
                <h5 className="profil-type" style={{ color: "var(--secondary-color)" }}>
                  {" "}
                  Informations personnelles
                </h5>
              </div>

              <div className="row position-relative p-3 mb-5">
                <div className="col-md-4">
                  <div>
                    <p className="texte-gray">Prénom et Nom </p>
                    <p className="bloc-text-profil text-wrap">
                      {invest?.prenom + " " + invest?.nom}
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div>
                  <p className="texte-gray">Adresse email </p>
                    <p className="bloc-text-profil text-wrap">
                      {invest?.email || "Non défini"}
                    </p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div>
                    <p className="texte-gray">Numéro de téléphone</p>
                    <p className="bloc-text-profil">
                      {invest?.phone  || "Non défini"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row position-relative p-3 mb-5">
                <div className="col-md-4">
                  <div>
                    <p className="texte-gray">Titre du projet</p>
                    <p className="bloc-text-profil">{invest?.investisseur?.projet.nom || "Non défini"}</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div>
                    <p className="texte-gray">Montant investi</p>
                    <p className="bloc-text-profil">{invest?.users?.projet.projet_invest.montant || "Non défini"}</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div>
                    <p className="texte-gray">Type d'investissement</p>
                    <p className="bloc-text-profil">{invest?.projet?.mode_financement || "Non défini"}</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvestisseurDetails;
